// use-importation-details-data.ts
"use client";

import dayjs from "dayjs";

import IImportationDetails, { ImportationDetailsStatus } from "@/interfaces/importation-details";
import { ImportationDetailsMessages } from "@/messages/importationDetails/importation-details.messages";

interface Props {
  importation: IImportationDetails;
  messages: ImportationDetailsMessages;
}

interface Return {
  formattedDate: string;
  formattedCode: string;
  formattedName: string;
  formattedStatus: string;
  formattedMessage: string;
  bgColor?: "success" | "error" | "warning" | "info";
  isWarning: boolean;
}

function useImportationDetailsData({ importation, messages }: Props): Return {
  const formattedDate = importation.rowDate
    ? dayjs(importation.rowDate).format("DD/MM/YYYY HH:mm")
    : "-";

  const formattedCode = importation.code || "-";

  const formattedName = importation.name || "-";

  let formattedStatus = "-";
  let bgColor: "success" | "error" | "warning" | "info" | undefined = undefined;
  const status = String(importation.status ?? "").toUpperCase();

  switch (status) {
    case ImportationDetailsStatus.CREATED:
      formattedStatus = messages.createdOption;
      bgColor = "success";
      break;
    case ImportationDetailsStatus.UPDATED:
      formattedStatus = messages.updatedOption;
      bgColor = "info";
      break;
    case ImportationDetailsStatus.WARNING:
      formattedStatus = messages.warningOption ?? "Aviso";
      bgColor = "warning";
      break;
    case ImportationDetailsStatus.ERROR:
      formattedStatus = messages.errorOption;
      bgColor = "error";
      break;
    default:
      formattedStatus = importation.status;
      bgColor = undefined;
      break;
  }

  const formattedMessage = importation.message || "-";

  return {
    formattedDate,
    formattedCode,
    formattedName,
    formattedStatus,
    formattedMessage,
    bgColor,
    isWarning: status === ImportationDetailsStatus.WARNING,
  };
}

export default useImportationDetailsData;
